import api from 'api'
import type {
  Category,
  VerificationType,
} from 'api/company/position/requirement/types'

type PositionRequirement = {
  category: Category
  id: number
  isWorkerVisible: boolean
  mustHave: boolean
  name: string
  verificationType: VerificationType
  addedAt: string
}

type PositionDetail = {
  about: string
  allowAutocushion: boolean
  bundling: 'none' | 'instance' | null
  clockInCodeEnabled: boolean
  clockOutCodeEnabled: boolean
  company: {
    companyGroupId: number | null
    id: number
    name: string
    type: '1099' | 'w2'
  }
  createdAt: string
  hidden: boolean
  id: number
  isApproved: boolean
  isTipEligible: boolean
  name: string
  needsCar: boolean
  needsLicense: boolean
  positionTemplate: {
    id: number
    name: string
  }
  prescreened: boolean
  requirements: PositionRequirement[]
}

export const getPositionById = async (
  positionId: number
): Promise<PositionDetail> => {
  const response = await api.get<PositionDetail>(
    `/admin/positions/${positionId}`
  )
  return response.data
}
